import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  // Mantém os estilos do exemplo anterior
  root: {
    width: '100%',
    padding: '0 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    margin: '8px 0 0 0'
  },
  titleMenu: {
    '& span': {
      fontWeight: 'bold',
      fontSize: '1.1rem',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      marginBottom: theme.spacing(2)
    }
  },
  stepperContainer: {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '12px',
      left: '12px',
      height: 'calc(100% - 24px)',
      width: '1px',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_300.main
    }
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    position: 'relative'
  },
  stepIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    zIndex: 1,
    flexShrink: 0,
    marginRight: theme.spacing(1)
  },
  inputGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    // backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.gray_100.main,
    color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
    cursor: 'pointer',
    marginTop: theme.spacing(2),
    position: 'relative',
    zIndex: 9,  
  },
  plusIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    // border: `2px solid ${theme.palette.blue_300.main}`,
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.blue_300.main,
    fontWeight: 'bold',
    '& svg':{
      color: theme.palette.white_100.main,
    }
  },
  actionButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },

  iconButtonDelete:{
    backgroundColor: 'transparent',
    color: theme.palette.red_100.main,
    '&:hover': {
      backgroundColor: 'transparent'  
  }
}
}))
